<template>
  <div class="mt-4 px-5">
    <v-alert v-if="errorNoClub" type="warning" dense text shaped>
      Du bist aktuell in keinem Verein als Schießleiter eingetragen.
    </v-alert>

    <div v-for="club in comp_SchiessleiterToday" :key="club.club_id" class="mb-6">
      <v-card outlined>
        <v-card-title class="py-2 px-4" style="background-color: #e8f5e9;">
          <v-icon class="mr-2" color="green darken-2">mdi-shield-account</v-icon>
          {{ club.club_name }}
        </v-card-title>

        <v-card-text class="pa-2">

          <v-data-table
            :headers="headers_SL"
            :items="club.TodaySL"
            class="elevation-1 my-2"
            hide-default-footer
            no-data-text="Kein Schiessleiter eingebucht"
          >
            <template v-slot:top>
              <v-toolbar flat color="warning">
                <h3>Schiessleiter</h3>
                <v-spacer></v-spacer>
                <v-btn icon @click="reload">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </v-toolbar>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.beenden="{ item }">
              <v-btn class="error my-1" text @click="endeEntry(item)">
                <v-icon>mdi-clock-end</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <v-data-table
            :headers="headers_SA"
            :items="club.TodaySA"
            class="elevation-1 my-2"
            hide-default-footer
            no-data-text="Kein Standaufsicht eingebucht"
            :item-class="itemRowClassSA"
          >
            <template v-slot:top>
              <v-toolbar flat color="info">
                <h3>Standaufsicht</h3>
                <v-spacer></v-spacer>
                <v-btn icon @click="reload">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </v-toolbar>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.allein_aufsicht="{ item }">
              <v-icon v-if="!item.allein_aufsicht" color="success">mdi-check</v-icon>
              <v-icon v-if="item.allein_aufsicht" color="red">mdi-window-close</v-icon>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.beenden="{ item }">
              <v-btn class="error my-1" text @click="endeEntry(item)">
                <v-icon>mdi-clock-end</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <v-data-table
            :headers="headers_user"
            :items="club.Today"
            sort-by="KurzBez"
            group-by="KurzBez"
            class="elevation-1 my-2"
            no-data-text="Kein Schütze eingebucht"
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat color="success">
                <h3>Schützen</h3>
                <v-spacer></v-spacer>
                <v-btn icon @click="reload">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </v-toolbar>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.beenden="{ item }">
              <v-btn class="error my-1" text @click="endeEntry(item)">
                <v-icon>mdi-clock-end</v-icon>
              </v-btn>
            </template>
          </v-data-table>

        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import * as Ably from 'ably';
import { API } from '@/plugins/axios';

export default {
  name: 'schiessleiterToday',

  data: () => ({
    ablyClient: null,
    channels: [],
    shouldReconnect: true,
    reconnectAttempts: 0,
    errorNoClub: false,

    headers_SL: [
      { text: 'Name', value: 'name', sortable: false, width: '200px' },
      { text: 'Vorname', value: 'vorname', width: '200px' },
      { text: 'Begin', value: 'BeginFormat', width: '200px' },
      { text: 'Beenden', value: 'beenden', sortable: false, align: 'right', width: '120px' }
    ],
    headers_SA: [
      { text: 'Name', value: 'name', sortable: false, width: '200px' },
      { text: 'Vorname', value: 'vorname', width: '200px' },
      { text: 'Begin', value: 'BeginFormat', width: '200px' },
      { text: 'Stand', value: 'KurzBez', width: '200px' },
      { text: 'Aufsicht Regulär', value: 'allein_aufsicht', align: 'center', width: '120px' },
      { text: 'Beenden', value: 'beenden', sortable: false, align: 'right', width: '120px' }
    ],
    headers_user: [
      { text: 'Name', value: 'name', sortable: false, width: '200px' },
      { text: 'Vorname', value: 'vorname', width: '200px' },
      { text: 'Begin', value: 'BeginFormat', width: '200px' },
      { text: 'Stand', value: 'KurzBez', width: '200px' },
      { text: 'Bahn', value: 'bahn', width: '100px' },
      { text: 'Beenden', value: 'beenden', sortable: false, align: 'right', width: '120px' }
    ]
  }),

  computed: {
    comp_SchiessleiterToday() {
      return this.$store.state.UserApp.SchiessleiterToday;
    }
  },

  async created() {
    this.shouldReconnect = true;
    try {
      await this.$store.dispatch('UserApp/getSchiessleiterToday');
    } catch (err) {
      if (err?.response?.status === 403) {
        this.errorNoClub = true;
        return;
      }
    }

    // Ohne Schießleiter-Recht liefert das Backend eine leere Liste statt 403
    this.errorNoClub = this.comp_SchiessleiterToday.length === 0;

    if (this.comp_SchiessleiterToday.length > 0) {
      await this.startWebSocket();
    }
  },

  beforeDestroy() {
    this.shouldReconnect = false;
    this.channels.forEach(ch => ch.unsubscribe());
    this.channels = [];
    if (this.ablyClient) {
      this.ablyClient.close();
      this.ablyClient = null;
    }
    this.$store.dispatch('GeneralApp/Websocket_state', false);
  },

  methods: {
    async startWebSocket() {
      if (this.ablyClient) {
        this.ablyClient.close();
        this.ablyClient = null;
        this.channels = [];
      }

      this.ablyClient = new Ably.Realtime({
        // Token jedes Mal frisch über die API: aktueller User-Token, abgelaufener wird per Refresh erneuert
        authCallback: (tokenParams, callback) => {
          API.post('user/ably/token')
            .then(resp => callback(null, resp.data))
            .catch(err => callback((err && err.message) || 'Ably-Token konnte nicht geholt werden', null));
        },
        autoConnect: true,
        recover: (lastConnectionDetails, cb) => {
          console.log('Recovering Ably Schießleiter session');
          cb(true);
        }
      });

      this.ablyClient.connection.on((stateChange) => {
        console.log('Schießleiter Ably Status:', stateChange.current);

        if (stateChange.current === 'connected' && this.channels.length === 0) {
          this.reconnectAttempts = 0;
          this.subscribeToClubChannels();
          this.$store.dispatch('GeneralApp/Websocket_state', true);
        }

        if (stateChange.current === 'disconnected' || stateChange.current === 'suspended') {
          this.$store.dispatch('GeneralApp/Websocket_state', false);
          this.scheduleReconnect();
        }

        if (stateChange.current === 'failed' || stateChange.current === 'closed') {
          this.$store.dispatch('GeneralApp/Websocket_state', false);
          if (this.shouldReconnect) {
            this.scheduleReconnect();
          }
        }
      });
    },

    subscribeToClubChannels() {
      this.comp_SchiessleiterToday.forEach(club => {
        const ch = this.ablyClient.channels.get(`private:clubs.${club.club_id}.ClubTodayChannel`);
        ch.subscribe((message) => {
          if (message?.data?.message) {
            const { Today, TodaySA, TodaySL } = message.data.message;
            if (Today !== undefined && TodaySA !== undefined && TodaySL !== undefined) {
              this.$store.commit('UserApp/UPDATE_SCHIESSLEITER_TODAY_CLUB', {
                club_id: club.club_id,
                Today,
                TodaySA,
                TodaySL
              });
            }
          }
        });
        this.channels.push(ch);
      });
    },

    scheduleReconnect() {
      if (!this.shouldReconnect) return;
      const delay = Math.min(30000, 1000 * Math.pow(2, this.reconnectAttempts));
      this.reconnectAttempts++;
      setTimeout(() => {
        if (this.shouldReconnect) {
          this.startWebSocket();
        }
      }, delay);
    },

    reload() {
      this.$store.dispatch('UserApp/getSchiessleiterToday');
    },

    endeEntry(item) {
      this.$store.dispatch('UserApp/schiessleiterEndEntry', { shootingbook_id: item.id });
    },

    itemRowClassSA(item) {
      return item.allein_aufsicht === 1 ? 'blue lighten-4' : '';
    }
  }
};
</script>
